export const Content = ({ children }: { children: JSX.Element | JSX.Element[] }) => {
    return (
        <div className="relative bg-white overflow-hidden isolate rounded-t-3xl -mt-12 flex-auto flex flex-col">
            {children}
        </div>
    );
};
